<template>
  <el-container direction="vertical" :class="{ 'no-header': hideHeader }">
    <el-header v-if="!hideHeader">
      <page-header
        :page-title="pageTitle"
        :tabs="tabs"
        :tab-id="tabId"
        :custom-back="customBack"
        v-on="$listeners"
      ></page-header>
    </el-header>
    <el-main>
      <slot name="main-content"></slot>
    </el-main>
  </el-container>
</template>

<script>
import PageHeader from "@/components/PageHeader";
export default {
  name: "MainLayout",
  components: { PageHeader },
  props: {
    pageTitle: {
      type: String,
      default: "页面标题",
    },
    tabs: {
      type: Array,
      default: () => [],
    },
    tabId: {
      type: [Number, String],
      default: 0,
    },
    customBack: {
      type: Boolean,
      default: false,
    },
    // 隐藏头部导航栏（H5 下需对外分享 / 免登录访问的页面使用）
    hideHeader: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.el-container {
  height: 100%;
}
// ⚠️ 模板上必须显式写 direction="vertical"：Element UI 的 el-container 是按
// 「slot 里是否有 el-header/el-footer」推断方向的（computed 依赖 $slots，而 $slots 非响应式）。
// 本组件给 el-header 加了 v-if="!hideHeader"，一旦隐藏就会推断成横向 → header 与 main 并排
// （main 被挤到右侧、顶部/左侧大片漏底）。固定 direction 可避免。
.el-header {
  height: 80px !important;
  padding: 0;
}
.el-main {
  box-sizing: border-box;
  height: calc(100% - 80px);
  min-height: calc(100% - 80px);
  background: #f7f9fb;
  padding: 0;
}
// 隐藏头部时主内容区占满整屏（否则 calc(100% - 80px) 会留出一截空白）
.no-header .el-main {
  height: 100%;
  min-height: 100%;
}
</style>
